import { TableColumnRowInterface, tableColumns } from 'components/tables/table-body.helper';
import React from 'react';
import { ChatbotSettingsInterface } from 'interfaces/chatbot-settings.interface';

function ChatbotSettingsTabledata(): TableColumnRowInterface[] {
  const columnData = [
    {
      key: 'name',
      render: (rowData: ChatbotSettingsInterface) => {
        const id = rowData?._id;
        return (
          <div className="flex flex-row">
            <a href={`/dashboard/chatbot-settings/${id}`} className="hover:underline">
              {rowData?.name}
            </a>
          </div>
        );
      },
    },
    {
      key: 'url',
      render: (rowData: ChatbotSettingsInterface) => {
        return <div className="flex flex-row">{rowData?.url || '--'}</div>;
      },
    },

    {
      key: 'path',
      render: (rowData: ChatbotSettingsInterface) => {
        return <div className="flex flex-row">{rowData?.path}</div>;
      },
    },
    {
      key: 'environment',
      render: (rowData: ChatbotSettingsInterface) => {
        return <div className="flex flex-row">{rowData?.environment}</div>;
      },
    },
  ];

  return tableColumns(columnData);
}

export default ChatbotSettingsTabledata;
